import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Layout from '../Layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/front/home/home.vue'),
        meta: {
          title: '筑盾-工程管理平台' // 设置页面标题
        }
        // 首页
      },
      {
        path: '/personalCenter',
        component: () => import('@/views/front/personalCenter/personalCenter.vue')
        // 个人中心
      },
      {
        path: '/bulletinBoard',
        component: () => import('@/views/bulletinBoard/index.vue')
        // 项目看板
      },
      {
        path: '/projectList',
        component: () => import('@/views/projectManage/projectList/index.vue')
        // 项目管理-项目列表
      },
      {
        path: '/createProject',
        component: () => import('@/views/projectManage/createProject/index.vue')
        // 项目管理-创建/编辑项目
      },
      {
        path: '/projectLog',
        component: () => import('@/views/projectManage/projectLog/index.vue')
        // 项目管理-日志列表
      },
      {
        path: '/myLog',
        component: () => import('@/views/projectManage/myLog/index.vue')
        // 项目管理-我的日志列表
      },
      {
        path: '/projectLogComment',
        component: () => import('@/views/projectManage/projectLogComment/index.vue')
        // 项目管理-日志评价列表
      },
      {
        path: '/projectMemberList',
        component: () => import('@/views/projectManage/projectMember/index.vue')
        // 项目管理-成员管理
      },
      
      {
        path: '/publishLogs',
        component: () => import('@/views/projectManage/publishLogs/index.vue')
        // 项目管理-发布/编辑日志
      },
      {
        path: '/progressTaskList',
        component: () => import('@/views/progressTaskManage/progressTaskList/index.vue')
        // 进度任务管理-进度任务列表
      },
      {
        path: '/myProgress',
        component: () => import('@/views/progressTaskManage/myProgress/index.vue')
        // 进度任务管理-我的进度任务列表
      },
      {
        path: '/createTask',
        component: () => import('@/views/progressTaskManage/createTask/index.vue')
        // 进度任务管理-创建/发布进度任务
      },
      {
        path: '/eventTaskList',
        component: () => import('@/views/eventTaskManager/eventTaskList/index.vue')
        // 事件任务管理-事件任务列表
      },
      {
        path: '/createEventTask',
        component: () => import('@/views/eventTaskManager/createEventTask/index.vue')
        // 事件任务管理-创建/修改事件任务
      },
      {
        path: '/customerService',
        component: () => import('@/views/me/customerService/index.vue')
        // 我的-客服中心
      },
      {
        path: '/feedback',
        component: () => import('@/views/me/feedback/index.vue')
        // 我的-意见反馈
      },
      {
        path: '/feedbackHistory',
        component: () => import('@/views/me/feedbackHistory/index.vue')
        // 我的-反馈历史
      },
      {
        path: '/contactUs',
        component: () => import('@/views/me/contactUs/index.vue')
        // 我的-联系我们
      },
      {
        path: '/instructionManual',
        component: () => import('@/views/me/instructionManual/index.vue')
        // 我的-操作说明
      },
      {
        path: '/instructionManualInfo',
        component: () => import('@/views/me/instructionManualInfo/index.vue')
        // 我的-操作说明-详情
      },
      {
        path: '/reviewList',
        component: () => import('@/views/collaborativeManager/reviewList/index.vue')
        // 协作事项管理-审核管理列表
      },
      {
        path: '/withdrawalList',
        component: () => import('@/views/collaborativeManager/withdrawalList/index.vue')
        // 协作事项管理-支款申请列表
      },
      {
        path: '/chapterList',
        component: () => import('@/views/collaborativeManager/chapterList/index.vue')
        // 协作事项管理-用章申请列表
      },
      {
        path: '/leaveList',
        component: () => import('@/views/collaborativeManager/leaveList/index.vue')
        // 协作事项管理-请假申请列表
      },
      {
        path: '/otherList',
        component: () => import('@/views/collaborativeManager/otherList/index.vue')
        // 协作事项管理-其他申请列表
      },
      {
        path: '/reimbursementList',
        component: () => import('@/views/collaborativeManager/reimbursementList/index.vue')
        // 协作事项管理-报销申请列表
      },
      {
        path: '/addWithdrawal',
        component: () => import('@/views/collaborativeManager/addWithdrawal/index.vue')
        // 协作事项管理-新增支款
      },
      {
        path: '/addChapter',
        component: () => import('@/views/collaborativeManager/addChapter/index.vue')
        // 协作事项管理-新增用章
      },
      {
        path: '/addLeave',
        component: () => import('@/views/collaborativeManager/addLeave/index.vue')
        // 协作事项管理-新增请假
      },
      {
        path: '/addOthers',
        component: () => import('@/views/collaborativeManager/addOthers/index.vue')
        // 协作事项管理-新增其他
      },
      {
        path: '/addReimbursement',
        component: () => import('@/views/collaborativeManager/addReimbursement/index.vue')
        // 协作事项管理-新增报销
      },
      {
        path: '/attendanceSetting',
        component: () => import('@/views/attendanceManager/attendanceSetting/index.vue')
        // 考勤管理-考勤设置
      },
      {
        path: '/attendanceRecord',
        component: () => import('@/views/attendanceManager/attendanceRecord/index.vue')
        // 考勤管理-考勤记录
      },
      {
        path: '/cardReplacementApply',
        component: () => import('@/views/attendanceMakeUpCard/cardReplacementApply/index.vue')
        // 补卡管理-补卡申请
      },
      {
        path: '/cardReplacementList',
        component: () => import('@/views/attendanceMakeUpCard/cardReplacementList/index.vue')
        // 补卡管理-补卡列表
      },
      {
        path: '/cardReplacementSettings',
        component: () => import('@/views/attendanceMakeUpCard/cardReplacementSettings/index.vue')
        // 补卡管理-补卡设置
      },
      {
        path: '/inventoryList',
        component: () => import('@/views/inventoryManager/inventoryList/index.vue')
        // 库存管理-库存列表
      },
      {
        path: '/inventoryRecords',
        component: () => import('@/views/inventoryManager/inventoryRecords/index.vue')
        // 库存管理-库存记录
      },
      {
        path: '/requisitionList',
        component: () => import('@/views/inventoryManager/requisitionList/index.vue')
        // 库存管理-领用申请
      },
      {
        path: '/addRequisition',
        component: () => import('@/views/inventoryManager/addRequisition/index.vue')
        // 库存管理-新增领用
      },
      {
        path: '/returnList',
        component: () => import('@/views/inventoryManager/returnList/index.vue')
        // 库存管理-归还申请列表
      },
      {
        path: '/unitList',
        component: () => import('@/views/inventoryManager/unitList/index.vue')
        // 库存管理-单位列表
      },
      {
        path: '/addReturn',
        component: () => import('@/views/inventoryManager/addReturn/index.vue')
        // 库存管理-新增归还
      },
      {
        path: '/legalAid',
        component: () => import('@/views/front/legalAid/legalAid.vue')
        // 法律援助
      },
      {
        path: '/platformMessages',
        component: () => import('@/views/message/platformMessages/index.vue')
        // 消息-平台消息
      },
      {
        path: '/platformMessageDetails',
        component: () => import('@/views/message/platformMessageDetails/index.vue')
        // 消息-平台消息详情
      },
      {
        path: '/projectAnnouncement',
        component: () => import('@/views/message/projectAnnouncement/index.vue')
        // 消息-项目公告
      },
      {
        path: '/newsMessage',
        component: () => import('@/views/message/newsMessage/index.vue')
        // 消息-新闻动态
      },
      {
        path: '/addressBook',
        component: () => import('@/views/message/addressBook/index.vue')
        // 消息-通讯录
      },
      {
        path: '/addFriends',
        component: () => import('@/views/message/addFriends/index.vue')
        // 消息-添加好友
      },
      {
        path: '/friendApplicationList',
        component: () => import('@/views/message/friendApplicationList/index.vue')
        // 消息-好友审核列表
      },
      {
        path: '/chart',
        component: () => import('@/views/message/chart/index.vue')
        // 聊天
      },
      {
        path: '/myApplyLog',
        component: () => import('@/views/collaborativeManager/myApplyLog/index.vue')
        // 我的提交记录
      },
    ]
  },

  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('@/views/login/index.vue')
  // },
  {
    path: '/pwdLogin',
    name: 'pwdLogin',
    component: () => import('@/views/login/components/pwdLogin.vue')
  },
  {
    path: '/registerLogin',
    name: 'pwdLogin',
    component: () => import('@/views/login/components/registerLogin.vue')
  },
  {
    path: '/updatePwdLogin',
    name: 'updatePwdLogin',
    component: () => import('@/views/login/components/updatePwdLogin.vue')
  },
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('@/views/login/components/wxLogin.vue')
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: () => import('@/views/agreement/privacyAgreement.vue')
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: () => import('@/views/agreement/userAgreement.vue')
  },
]


const router = new VueRouter({
  routes
})

export default router
